import { createSelector } from 'reselect';

const ticketRootCausesData = (state) => state.ticketRootCausesData;

export const selectFilterData = () =>
  createSelector([ticketRootCausesData], (state) => state.filter);

export const selectCreationForm = () =>
  createSelector([ticketRootCausesData], (state) => state.creationForm);
